import styled from 'styled-components';

export const DeleteButtonContainer = styled.div`
  min-block-size: 3.7rem;
`;

export const TextFieldStyled = styled(DeleteButtonContainer)`
  flex-basis: 50%;
`;
